import { useContext, useEffect } from 'react';
import { ReferencesContext } from './ReferencesContext';

export const useReferences = () => {
  const context = useContext(ReferencesContext);

  if (!context) {
    throw new Error('useReferences must be used within ReferencesProvider');
  }

  const { references, loading, loadReferences } = context;

  useEffect(() => {
    loadReferences();
  }, [loadReferences]);

  return {
    references,
    loading
  };
};
